import { configureStore } from "@reduxjs/toolkit";
import eventReducer from "./eventSlice";
import profileReducer from "./profileSlice";
import sharedEventsReducer from "./sharedEventsSlice";
import membershipReducer from "./membershipSlice";

export const store = configureStore({
  reducer: {
    events: eventReducer,
    profile: profileReducer,
    sharedEvents: sharedEventsReducer,
    memberships: membershipReducer,
  },
});
